<template>

  <section>

    <div style="height: 10px;">&nbsp;</div>

    <!-- <div class="img">
      <div>
        <img src="../assets/top1.jpg" style="width: 100%;height: 130px;" />
      </div>
    </div> -->

    <!-- <div class="img">
      <div>
        <img src="../assets/top2.jpg" style="width: 100%;height: 450px;" />
      </div>
    </div> -->

    <div class="img" v-if="isShare == false">
      <div>
        <img src="../assets/top2.jpg" style="width: 100%;height: 500px;" />
        <img src="../assets/phone.jpg" style="width: 100%;height: 200px;" />
      </div>
    </div>

    <div class="img" v-if="isShare == true">
      <div>
        <img src="../assets/top2.jpg" style="width: 100%;height: 450px;" />
        <img src="../assets/phone.jpg" style="width: 100%;height: 200px;" />
      </div>
      <div style="text-align: center;color: #00391E;font-weight: bold;font-size: 18px;margin: 5px 0;">
        谢谢您的参与，已经为您的朋友助力优惠！
      </div>
    </div>

    <div style="margin-left: 10px;" v-if="isMe == true">
      <Progress :percent="progress" :stroke-width="20" status="active" :stroke-color="['#FFFFFF','#00391E']"
        style="width: 100%;"><span style="color: #00391E;">{{progressText}}</span></Progress>
    </div>

    <button class="appointment" v-on:click="jumpDetail()" v-if="isGet == true"
      style="display: block;margin-bottom: 10px;padding: 5px;background:#00391E;font-weight: bold;font-size: 20px !important;color: #FFFFFF;">一键领取接送券</button>

    <div class="demand" v-if="isRule == true">
      <div>
        <img src="../assets/userule1.jpg" style="width: 100%;height: 200px;" />
        <img src="../assets/userule2.jpg" style="width: 100%;height: 180px;" />
        <img src="../assets/userule3.jpg" style="width: 100%;height: 180px;" />
        <img src="../assets/userule4.jpg" style="width: 100%;height: 150px;" />
      </div>
      <!-- <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">接送券领取规则：<span
          style="color: #2754BB;margin-left: 10px;font-size: 12px !important;color: red;font-weight: bold;"
          @click="rule">{{ruleShow == true?'(收起)':'(展开)'}}</span></div>
      <div v-if="ruleShow == true" style="width:100%;margin-bottom:5px;">1、在中山候机楼购买广州出发的机票且在过去一年内有使用过我司的接送服务或专车服务；</div>
      <div v-if="ruleShow == true" style="width:100%;margin-bottom:5px;">2、在中山候机楼购买广州出发的机票且转发此链接到朋友圈获朋友助力20以上；</div>
      <div v-if="ruleShow == true" style="width:100%;margin-bottom:5px;">3、满足任一条件的旅客，仅需加9.9元即可享受中山全市-中山候机楼单次接送；</div> -->
    </div>

    <div class="lineProd" v-if="coupon == true" style="text-align: center;">
      <img src="../assets/9.9.jpg" style="width: 90%;height:90px;margin:0 0 10px" v-if="tenCoupon == true"
        v-on:click="userCoupon(tenID,tenTitle)" />
      <img src="../assets/29.9.jpg" style="width: 90%;height:90px;margin:0 0 10px" v-if="twonineCoupon == true"
        v-on:click="userCoupon(twonineID,twonineTitle)" />
      <img src="../assets/bus.jpg" style="width: 90%;height:90px;margin:0 0 10px" v-if="busCoupon == true"
        v-on:click="userCoupon(busID,busTitle)" />
      <img src="../assets/park.jpg" style="width: 90%;height:90px;margin:0 0 10px" v-if="parkCoupon == true"
        v-on:click="userCoupon(parkID,parkTitle)" />
    </div>

    <!-- <div style="width: 96%;margin: 0 2% 10px;text-align: center;font-size: 20px;color:  #2754BB;">政企商务机票预约下单</div> -->

    <div class="demand" v-if="infoShow == true">
      <div style="width: 100%;background: #e6e6e6;color: black;padding-left: 10px;">预约信息填写：</div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的称呼：(必填)</div>
        <Input v-model="name" clearable placeholder="" />
      </div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>您的联系电话：(必填)</div>
        <Input v-model="phone" type="tel" clearable placeholder="" />
      </div>
      <div style="width:100%;">
        <div style="padding-left:10px;"><span style="color: red;">*</span>出行人数：(必填)<span
            style="color: red;">{{isUse}}</span></div>
        <Input v-model="address" clearable placeholder="" />
      </div>
      <div>
        <div style="padding-left:10px;"><span style="color: red;">*</span>预约航班信息：(必填)</div>
        <Input v-model="demand" placeholder="具体行程（如5月15日,广州-重庆）" clearable type="textarea"
          :autosize="{minRows: 4,maxRows: 4}" />
      </div>
    </div>

    <button class="appointment" v-on:click="appointment()"  v-if="infoShow == true"
      style="display: block;margin-bottom: 10px;padding: 5px;background:#00391E;font-weight: bold;font-size: 20px !important;color: #FFFFFF;">预约使用接送劵</button>

    <div style="width: 96%;margin: 0 2%;text-align: center;">中山候机楼丨18988598961 / 18029902235</div>

  </section>
</template>

<script>
  import flightApi from '../request/flightApi';
  import baseTool from '../utils/baseFunction';
  import addressApi from '../request/addressApi';
  import userApi from '../request/userApi';
  import axios from 'axios';
  export default {
    name: 'FlightCoupon',
    data() {
      return {
        demand: '',
        name: '',
        phone: '',
        address: '',

        isGet: true,
        coupon: false,

        tenCoupon: false,
        tenID: '',
        tenTitle: '',

        busCoupon: false,
        busID: '',
        busTitle: '',

        parkCoupon: false,
        parkID: '',
        parkTitle: '',

        twonineCoupon: false,
        twonineID: '',
        twonineTitle: '',

        couponid: '',
        progress: 0,
        progressText: '',
        ruleShow: false,
        hasPick: false,
        isUse: '',
        isMe: false,
        isShare: false,
        infoShow:false,
        isRule:true,
        recordId:'99999999',
      };
    },
    components: {},
    mounted() {
      // this.shopFriend();
      document.querySelector('body').setAttribute('style', 'background-color:#FFFFFF;overflow-y: scroll;height: auto;');
      this.getUserAddress();
      this.shopFriend();
      this.getphoneType();

      if (this.$route.params.openid && this.$route.params.openid.length && this.$route.params.openid == 0) {
        userApi.GetCardList(this.$store.state.user.OpenId).then(getcardRes => {
          console.log('getcardRes', getcardRes)
          this.cardList = getcardRes.data;
          if (getcardRes.success == true) {
            this.isGet = true;
            this.coupon = false;
            getcardRes.data.forEach(cardObj => {
              if (cardObj.CardID == 9 && cardObj.CardStatu == 0) {
                this.tenCoupon = true;
                this.tenID = cardObj.CardID;
                this.tenTitle = cardObj.Caedinfo.CardTitle;
                this.isGet = true;
                this.coupon = true;
              }
              if (cardObj.CardID == 11 && cardObj.CardStatu == 0) {
                this.parkCoupon = true;
                this.parkID = cardObj.CardID;
                this.parkTitle = cardObj.Caedinfo.CardTitle;
                this.isGet = true;
                this.coupon = true;
              }
              if (cardObj.CardID == 13 && cardObj.CardStatu == 0) {
                this.busCoupon = true;
                this.busID = cardObj.CardID;
                this.busTitle = cardObj.Caedinfo.CardTitle;
                this.isGet = true;
                this.coupon = true;
              }
              if (cardObj.CardID == 14 && cardObj.CardStatu == 0) {
                this.twonineCoupon = true;
                this.twonineID = cardObj.CardID;
                this.twonineTitle = cardObj.Caedinfo.CardTitle;
                this.isGet = true;
                this.coupon = true;
              }
            })
          }
        })
      }
      if (this.$route.params.openid && this.$route.params.openid.length && this.$route.params.openid != 0) {
        this.isShare = true;
        // this.prodShow = false;
        // if(this.$route.params.openid != this.$store.state.user.OpenId){
        flightApi.saveSearchFlightRecord1(this.$store.state.user.OpenId, this.$route.params.openid, 2, baseTool.formatterDate(new Date()), '接送劵',this.phoneType).then(sucRes => {
          this.recordId =  sucRes.data.ID
          if (this.$route.params.openid != this.$store.state.user.OpenId) {} else {
            // this.prodShow = true;
            this.isMe = true;
            this.isShare = false;
            // this.isFriend = true;

            userApi.GetCardList(this.$store.state.user.OpenId).then(getcardRes => {
              console.log('getcardRes', getcardRes)
              this.cardList = getcardRes.data;
              if (getcardRes.success == true) {
                this.tenCoupon = false;
                this.busCoupon = false;
                this.parkCoupon = false;
                this.twonineCoupon = false;
                this.isGet = true;
                this.coupon = false;

                getcardRes.data.forEach(cardObj => {
                  if (cardObj.CardID == 9 && cardObj.CardStatu == 0) {
                    this.tenCoupon = true;
                    this.tenID = cardObj.CardID;
                    this.tenTitle = cardObj.Caedinfo.CardTitle;
                    this.isGet = true;
                    this.coupon = true;
                  }
                  if (cardObj.CardID == 13 && cardObj.CardStatu == 0) {
                    this.busCoupon = true;
                    this.busID = cardObj.CardID;
                    this.busTitle = cardObj.Caedinfo.CardTitle;
                    this.isGet = true;
                    this.coupon = true;
                  }
                  if (cardObj.CardID == 11 && cardObj.CardStatu == 0) {
                    this.parkCoupon = true;
                    this.parkID = cardObj.CardID;
                    this.parkTitle = cardObj.Caedinfo.CardTitle;
                    this.isGet = true;
                    this.coupon = true;
                  }
                  if (cardObj.CardID == 14 && cardObj.CardStatu == 0) {
                    this.twonineCoupon = true;
                    this.twonineID = cardObj.CardID;
                    this.twonineTitle = cardObj.Caedinfo.CardTitle;
                    this.isGet = true;
                    this.coupon = true;
                  }
                })

              }
            })

            if (sucRes.data.Times < 20) {
              this.progressText = '已经有' + sucRes.data.Times + '个朋友为您优惠加码！';
              this.progress = sucRes.data.Times * 5;
            } else {
              this.progress = 100;
              this.progressText = '助力成功,立即领劵！(已经有' + sucRes.data.Times + '个朋友为您优惠加码)';
            }

          }
        });
        // }
      }


    },
    activated() {},
    methods: {
      getphoneType(){
        //获取userAgent信息
        var userAgentStr = navigator.userAgent;
        var iPhone = new RegExp("iPhone");
        var Android = new RegExp("Android");;
        if(iPhone.test(userAgentStr)){
          this.phoneType = "iPhone";
        }
        else if(Android.test(userAgentStr)){
          this.phoneType = userAgentStr.split('(Linux; Android ')[1].split('; ')[1].split(' Build')[0]
        }
      },
      getUserAddress() {
        userApi.getUserData(this.$store.state.user.OpenId).then(sucRes => {
          if (sucRes.success && sucRes.totalCount > 0) {
            this.name = sucRes.data.RealName;
            this.phone = sucRes.data.Mobile;
          }
        })
      },
      rule() {
        this.ruleShow = !this.ruleShow;
      },
      jumpDetail() {
        var that = this;

        // this.isGet = false;
        // this.coupon = true
        // this.tenCoupon = true;

        userApi.GetCardList(this.$store.state.user.OpenId).then(getcardRes => {
          console.log('getcardRes', getcardRes)
          that.cardList = getcardRes.data;
          if (getcardRes.success == false) {
            userApi.QueryCardList().then(cardRes => {
              console.log('cardRes', cardRes)
              if (cardRes.success == true && cardRes.totalCount > 0) {
                that.cardList = cardRes.data;
                cardRes.data.forEach(obj => {
                  if(obj.ID == 9 || obj.ID == 11 || obj.ID == 13 || obj.ID == 14){
                    userApi.PutCard(obj.ID, that.$store.state.user.OpenId,this.recordId).then(putRes => {
                      console.log('putRes', putRes)
                      if (putRes.success == true) {

                        if(putRes.data.CardID == 9){
                          this.isGet = true;
                          this.coupon = true;
                          this.tenCoupon = true;
                          this.$Modal.success({
                            title: '恭喜您!',
                            content: '领劵成功！'
                          });
                        }
                        if(putRes.data.CardID == 11){
                          this.busCoupon = true;
                          this.isGet = true;
                          this.coupon = true;
                        }
                        if(putRes.data.CardID == 13){
                          this.parkCoupon = true;
                          this.isGet = true;
                          this.coupon = true;
                        }
                        if(putRes.data.CardID == 14){
                          this.twonineCoupon = true;
                          this.isGet = true;
                          this.coupon = true;
                        }

                      }
                      else if(putRes.message == "用户已领取优惠卡！"){
                        this.$Modal.error({
                          title: '温馨提示。',
                          content: '您已领取过此优惠券！'
                        });
                      }
                      else{
                        this.$Modal.error({
                          title: '抱歉，领券失败。',
                          content: '温馨提示：距离领券成功还差20个助力，立刻转发此链接到朋友圈获取助力吧！'
                        });
                      }
                    })
                  }
                })
              } else if (cardRes.totalCount <= 0) {
                this.isGet = false;
                this.isRule = false;
                this.coupon = false
                this.tenCoupon = false;
                this.busCoupon = false;
                this.parkCoupon = false;
                this.twonineCoupon = false;
                this.$Modal.error({
                  title: '很遗憾!',
                  content: '劵已领完！'
                });
              }
            })
          } else {

            getcardRes.data.forEach(cardObj => {
              if ((cardObj.CardID == 9 && cardObj.CardStatu == 0)||(cardObj.CardID == 11 && cardObj.CardStatu == 0)||(cardObj.CardID == 13 && cardObj.CardStatu == 0)||(cardObj.CardID == 14 && cardObj.CardStatu == 0)) {
                var hascoupon = true
              }
            })

            if (this.hascoupon == true) {
              this.tenCoupon = false;
              this.busCoupon = false;
              this.parkCoupon = false;
              this.twonineCoupon = false;
              this.isGet = true;
              this.coupon = false;
              getcardRes.data.forEach(cardObj => {
                if (cardObj.CardID == 9 && cardObj.CardStatu == 0) {
                  this.tenCoupon = true;
                  this.tenID = cardObj.CardID;
                  this.tenTitle = cardObj.Caedinfo.CardTitle;
                  this.isGet = true;
                  this.coupon = true;
                }
                if (cardObj.CardID == 11 && cardObj.CardStatu == 0) {
                  this.busCoupon = true;
                  this.busID = cardObj.CardID;
                  this.busTitle = cardObj.Caedinfo.CardTitle;
                  this.isGet = true;
                  this.coupon = true;
                }
                if (cardObj.CardID == 13 && cardObj.CardStatu == 0) {
                  this.parkCoupon = true;
                  this.parkID = cardObj.CardID;
                  this.parkTitle = cardObj.Caedinfo.CardTitle;
                  this.isGet = true;
                  this.coupon = true;
                }
                if (cardObj.CardID == 14 && cardObj.CardStatu == 0) {
                  this.twonineCoupon = true;
                  this.twonineID = cardObj.CardID;
                  this.twonineTitle = cardObj.Caedinfo.CardTitle;
                  this.isGet = true;
                  this.coupon = true;
                }
              })
            } else {
              userApi.QueryCardList().then(cardRes => {
                console.log('cardRes', cardRes)
                if (cardRes.success == true && cardRes.totalCount > 0) {
                  that.cardList = cardRes.data;
                  cardRes.data.forEach(obj => {
                    if(obj.ID == 9 || obj.ID == 11 || obj.ID == 13 || obj.ID == 14){
                      userApi.PutCard(obj.ID, that.$store.state.user.OpenId,this.recordId).then(putRes => {
                        console.log('putRes', putRes)
                        // if (putRes.success == true) {
                        //   this.isGet = false;
                        //   this.coupon = true
                        //   this.tenCoupon = true;
                        //   this.busCoupon = true;
                        //   this.parkCoupon = true;
                        //   this.twonineCoupon = true;
                        //   this.$Modal.success({
                        //     title: '恭喜您!',
                        //     content: '领劵成功！'
                        //   });
                        // }
                        if (putRes.success == true) {

                          if(putRes.data.CardID == 9){
                            this.isGet = true;
                            this.coupon = true;
                            this.tenCoupon = true;
                            this.$Modal.success({
                              title: '恭喜您!',
                              content: '领劵成功！'
                            });
                          }
                          if(putRes.data.CardID == 11){
                            this.busCoupon = true;
                            this.isGet = true;
                            this.coupon = true;
                          }
                          if(putRes.data.CardID == 13){
                            this.parkCoupon = true;
                            this.isGet = true;
                            this.coupon = true;
                          }
                          if(putRes.data.CardID == 14){
                            this.twonineCoupon = true;
                            this.isGet = true;
                            this.coupon = true;
                          }

                        }
                        else if(putRes.message == "用户已领取优惠卡！"){
                          this.$Modal.error({
                            title: '温馨提示。',
                            content: '您已领取过此优惠券！'
                          });
                        }
                        else{
                          this.$Modal.error({
                            title: '抱歉，领券失败。',
                            content: '温馨提示：距离领券成功还差20个助力，立刻转发此链接到朋友圈获取助力吧！'
                          });
                        }
                      })
                    }
                  })
                } else if (cardRes.totalCount <= 0) {
                  this.isGet = false;
                  this.isRule = false;
                  this.coupon = false
                  this.tenCoupon = false;
                  this.busCoupon = false;
                  this.parkCoupon = false;
                  this.twonineCoupon = false;
                  this.$Modal.error({
                    title: '很遗憾!',
                    content: '劵已领完！'
                  });
                }
              })
            }
          }
        })
      },
      userCoupon(id, title) {
        this.isUse = '(已选择'+ title + ')'
        this.usercoupon = id;
        this.infoShow = true;
        this.isRule = false;
      },
      appointment() {
        var that = this;

        if (this.name == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的称呼不能为空'
          });
          return;
        }
        if (this.phone == '' || this.phone.length < 8 || this.phone.length > 11 || this.phone.length == 9 || this.phone
          .length == 10) {
          this.$Modal.warning({
            title: '操作提示',
            content: '您的联系电话不能为空或者电话号码长度不正确'
          });
          return;
        }
        if (this.address == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '出行人数不能为空'
          });
          return;
        }
        if (this.demand == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '航班信息不能为空'
          });
          return;
        }
        console.log(this.$store.state.user.OpenId, this.name, this.phone, this.demand, this.address);
        flightApi.appointmentFlight(
            this.$store.state.user.OpenId,
            '购广州机票+9.9预约',
            this.name,
            this.phone,
            '购广州机票+9.9预约:' + '航班信息:' + this.demand + '出行人数:' + this.address + '劵的ID' + this.couponid,
            null,
            null,
          )
          .then(sucRes => {
            this.demand = '';
            this.name = '';
            this.phone = '';
            this.address = '';
            if (sucRes.success == true) {
              this.$Modal.success({
                title: '恭喜您!',
                content: sucRes.message
              });
            } else {
              this.$Modal.error({
                title: '很遗憾!',
                content: sucRes.message
              });
            }
          });
      },
      shopFriend() {
        var that = this;
        wx.ready(function() { //需在用户可能点击分享按钮前就先调用
          wx.updateTimelineShareData({
            title: '分享朋友圈，中山懿峰候机楼旅客专属优惠！', // 分享标题
            link: 'http://www.callmefix.net/wechat/FlightCoupon/' + that.$store.state.user.OpenId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://www.callmefix.net/img/flightCoupon.jpg', // 分享图标
            success: function() {
              // 设置成功
              flightApi.saveSearchFlightRecord1(this.$store.state.user.OpenId, this.$store.state.user.OpenId, 2, baseTool.formatterDate(new Date()), '接送劵',this.phoneType).then(sucRes => {})
            }
          })
        });
      },
    },
  };
</script>

<style>
  .img {
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
    margin-bottom: 10px;
  }

  .demand {
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
    margin-bottom: 10px;
    font-size: 15px;
    border-radius: 8px;
  }

  .infomation {
    width: 96%;
    margin: 0 2%;
    border: 1px solid #bfbfbf;
  }

  .appointment {
    width: 94%;
    margin: 10px 3% 0 3%;
    background: #2754bb;
    color: white;
    height: 40px;
    font-size: 18px;
    border: 0;
    border-radius: 10px;
    line-height: 10px;
    /* margin-bottom: 10px; */
  }

  input::-webkit-input-placeholder {
    color: #515A6E;
  }

  input::-moz-input-placeholder {
    color: #515A6E;
  }

  input::-ms-input-placeholder {
    color: #515A6E;
  }

  .top_recognition {
    /* margin: 0 0 10px 0; */
  }

  .recognition {
    text-align: center;
  }

  .ivu-progress .ivu-progress-outer {
    padding-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flightCoupon.vue